<template>
  <div class="tabs">
    <i class="van-icon van-icon-arrow-left van-nav-bar__arrow" @click="onClickLeft" style="position:fixed;top: 20px;left: 20px;z-index:2;font-size: 17px;color: #fff"></i>
    <ul>
      <li :class="[currIndex==index? 'on' : '','tab']"  v-for="(item, index) in tabList" :key="index" @click="toggleTab(index, item.path)">
        <van-icon   :name="currIndex==index? item.active : item.normal"/>
        <a>{{item.title}}</a>
      </li>
      <!-- <li class="tab" @click="toggleTab('faultDetialsPage')">
        <van-icon  :name="require('../assets/zd@3x.png')"/>
        <a>终端详情</a>
      </li> -->
    </ul>
    <div :is="currentTab" class="tab-content" >
            <div v-show="currIndex==0">内容一</div>
            <div v-show="currIndex==1">内容二</div>
    </div>
    <!-- 子组件，显示不同的 tab
    is 特性动态绑定子组件
    keep-alive 将切换出去的组件保留在内存中 -->
    <!-- <keep-alive :is="currentTab">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </keep-alive> -->
  </div>

  <!-- <prince :is="currentTab" keep-alive></prince> -->
</template>

<script>
import Vue from 'vue'
import { Tabbar, TabbarItem, Tab, Tabs, Icon } from 'vant'

// 引入子组件
import xlDetialsPage from '@/views/xlDetialsPage.vue'
import faultDetialsPage from '@/views/faultDetialsPage.vue'

Vue.use(Tabbar, TabbarItem, Tab, Tabs, Icon)

export default {
  name: 'xlDiaresPage',
  components: {
    xlDetialsPage,
    faultDetialsPage,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Icon.name]: Icon
  },
  beforeMount () {
    //console.log(this.$route.path)
    if (this.$route.path === '/xlDetialsPage') {
      this.currIndex = 0
      this.currentTab = 'xlDetialsPage'
    } else if (this.$route.path === '/faultDetialsPage') {
      this.currIndex = 1
      this.currentTab = 'faultDetialsPage'
    }
  },
  activated () {
    // console.log(this.$route.path)
    if (this.$route.path === '/xlDiaresPage') {
      this.currIndex = 0
      this.currentTab = 'xlDetialsPage'
    } else if (this.$route.path === '/faultDetialsPage') {
      this.currIndex = 1
      this.currentTab = 'faultDetialsPage'
    }
    // console.log('activated')
    this.mlineId = this.$route.query.mlineId// 传过来的线路id
  },
  created () {
  },
  mounted () {
    this.mlineId = this.$route.query.mlineId// 传过来的线路id
  },
  methods: {
    onClickLeft () {
      // window.history.back()
      this.$router.go(-1)// 返回上一页面
      // this.$router.push({
      //   path: '/xlPage'
      // })
    },
    // tofaultDiares () {
    //   this.$router.push({
    //     path: '/faultDetialsPage' // 跳转到终端详情页
    //   })
    // },
    toggleTab: function (index, tab) {
      this.currentTab = tab // tab 为当前触发标签页的组件名
      this.currIndex = index
      // this.$router.replace(tab)
      this.$router.replace({ path: tab, query: { mlineId: this.mlineId } })
    }
    // menuShow: function (index) {
    //   this.menuIndex = index
    // }
  },
  computed: {},
  data () {
    return {
      pageHeight: window.innerHeight - 46,
      currIndex: 0,
      currentTab: 'xlDetialsPage', // 默认线路详情页（currentTab用于标识当前触发的子组件）
      mlineId: '', // 线路id
      menuIndex: -1,

      tabList: [
        {
          path: 'xlDetialsPage',
          title: '线路详情',
          normal: require('../assets/xl@3x.png'),
          active: require('../assets/xl-on@3x.png')
        },
        {
          path: 'faultDetialsPage',
          title: '终端详情',
          normal: require('../assets/zd@3x.png'),
          active: require('../assets/zd-on@3x.png')
        }
      ]
    }
  }
}
</script>

<style scoped lang="less">
/deep/.van-tabs--line .van-tabs__wrap {
  height: 46px;
}
/deep/.van-tabs__nav {
  background: linear-gradient(227deg, #06c8b5 0%, #007cf8 100%);
}
/deep/.van-nav-bar__title {
  font-size: 17px;
  font-weight: bold;
  color: #fff;
}
/deep/.van-nav-bar .van-icon {
  font-size: 17px;
  color: #fff;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
